/*
  Free UK delivery progress bar inside the AMP slide cart drawer (Hype Locker UK, added 5 Oct 2026).

  Whether the bar shows (UK market, Pokémon-only basket) and the threshold (shop metafield
  hl_shipping.pokemon_free_threshold) are decided on the server by snippets/hl-pokemon-shipping-bar.liquid
  and read here through /cart?view=hl-bar. This file only draws the bar in the drawer and keeps it in step
  with the drawer's own cart, so a discount code applied in the drawer is counted the same way the drawer's
  Subtotal counts it. The /cart page renders the same snippet itself and needs no script.
*/
(function () {
  'use strict';

  if (window.hlShipBarLoaded) return;
  window.hlShipBarLoaded = true;

  var STATE_URL = '/cart?view=hl-bar';
  var NODE_CLASS = 'hl-ship-bar--drawer';
  var HOOKS = [
    'SLIDECART_LOADED',
    'SLIDECART_UPDATED',
    'SLIDECART_OPENED',
    'SLIDECART_ADDED_TO_CART',
    'SLIDECART_REMOVED_FROM_CART',
    'SLIDECART_COUPON_APPLIED',
    'SLIDECART_DISCOUNT_REMOVED'
  ];

  var state = null; // last answer from the server: { show, total, count, threshold, currency }
  var busy = false; // a state request is running
  var again = false; // the cart changed while a request was running
  var timer = null;
  var lastItems = null; // which variants and quantities the last server answer was asked for
  var lastText = '';
  var observed = null;
  var observer = null;

  function ampCart() {
    try {
      var store = typeof window.SLIDECART_STATE === 'function' ? window.SLIDECART_STATE() : null;
      return store && store.cart ? store.cart : null;
    } catch (e) {
      return null;
    }
  }

  function itemsKey(cart) {
    if (!cart) return '';
    return (cart.items || [])
      .map(function (item) {
        return item.variant_id + ':' + item.quantity;
      })
      .join(',');
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency || 'GBP' }).format(cents / 100);
    } catch (e) {
      return '£' + (cents / 100).toFixed(2);
    }
  }

  function isOurs(node) {
    var el = node && (node.nodeType === 1 ? node : node.parentElement);
    return !!(el && el.closest && el.closest('.' + NODE_CLASS));
  }

  function draw() {
    var root = document.querySelector('.slidecarthq');
    if (!root) return;

    var node = root.querySelector('.' + NODE_CLASS);

    if (!state || !state.show || !state.threshold) {
      if (node) node.hidden = true;
      return;
    }

    if (!node) {
      node = document.createElement('div');
      node.className = 'hl-ship-bar ' + NODE_CLASS;
      node.innerHTML =
        '<p class="hl-ship-bar__text" role="status"></p>' +
        '<div class="hl-ship-bar__track" role="progressbar" aria-label="Progress towards free UK delivery" aria-valuemin="0" aria-valuemax="100">' +
        '<span class="hl-ship-bar__fill"></span></div>';
      lastText = '';
      var items = root.querySelector(':scope > .items');
      var header = root.querySelector(':scope > header');
      if (items) root.insertBefore(node, items);
      else if (header) header.after(node);
      else root.prepend(node);
    }

    // Prefer the drawer's own cart (it includes a discount code applied in the drawer) when it is the same basket.
    // Basket value = price before discounts minus all discounts. Not total_price: after a shipping estimate has been
    // made for the cart, the cart/change.js answer can carry the postage inside total_price.
    var cart = ampCart();
    var total = state.total;
    if (cart && typeof cart.original_total_price === 'number' && cart.item_count === state.count) {
      total = cart.original_total_price - (Number(cart.total_discount) || 0);
    }

    var left = Math.max(0, state.threshold - total);
    var done = left === 0;
    var percent = Math.max(0, Math.min(100, Math.floor((total * 100) / state.threshold)));
    var text = done
      ? "<strong>You've unlocked FREE UK delivery</strong>"
      : "You're <strong>" + money(left, state.currency) + '</strong> away from FREE UK delivery';

    if (text !== lastText) {
      node.querySelector('.hl-ship-bar__text').innerHTML = text;
      lastText = text;
    }
    node.querySelector('.hl-ship-bar__fill').style.width = percent + '%';
    node.querySelector('.hl-ship-bar__track').setAttribute('aria-valuenow', String(percent));
    node.classList.toggle('hl-ship-bar--done', done);
    node.hidden = false;
  }

  function refresh() {
    var cart = ampCart();
    if (cart && cart.item_count === 0) {
      state = { show: false };
      draw();
      return;
    }
    if (busy) {
      again = true;
      return;
    }
    busy = true;
    fetch(STATE_URL + '&t=' + Date.now(), { credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (res) {
        return res.ok ? res.text() : Promise.reject(new Error('HTTP ' + res.status));
      })
      .then(function (html) {
        var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-hl-ship-bar]');
        if (!el) return;
        state = {
          show: el.getAttribute('data-hl-show') === 'true',
          total: Number(el.getAttribute('data-hl-total')) || 0,
          count: Number(el.getAttribute('data-hl-count')) || 0,
          threshold: Number(el.getAttribute('data-hl-threshold')) || 0,
          currency: el.getAttribute('data-hl-currency') || 'GBP'
        };
      })
      .catch(function () {
        /* keep what is on screen; the next cart change asks again */
      })
      .then(function () {
        busy = false;
        draw();
        if (again) {
          again = false;
          refresh();
        }
      });
  }

  function onChange() {
    var cart = ampCart();
    if (!cart) return; // the drawer has not loaded its cart yet; it calls the hooks below once it has
    var key = itemsKey(cart);
    if (key !== lastItems) {
      lastItems = key;
      refresh();
    } else {
      draw();
    }
  }

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(onChange, delay);
  }

  function attach() {
    var holder = document.getElementById('slidecarthq') || document.querySelector('.slidecarthq');
    if (!holder) return false;
    if (observed === holder) return true;
    if (observer) observer.disconnect();
    observed = holder;
    observer = new MutationObserver(function (records) {
      var relevant = records.some(function (record) {
        if (isOurs(record.target)) return false;
        if (record.type === 'childList') {
          var moved = Array.prototype.slice.call(record.addedNodes).concat(Array.prototype.slice.call(record.removedNodes));
          if (moved.length && moved.every(isOurs)) return false;
        }
        return true;
      });
      if (relevant) schedule(80);
    });
    observer.observe(holder, { childList: true, subtree: true, characterData: true });
    schedule(0);
    return true;
  }

  // The drawer app calls these functions if the theme defines them. Keep any existing one working.
  HOOKS.forEach(function (name) {
    var previous = window[name];
    window[name] = function () {
      try {
        schedule(0);
      } catch (e) {
        /* never get in the way of the drawer */
      }
      return typeof previous === 'function' ? previous.apply(this, arguments) : undefined;
    };
  });

  var tries = 0;
  var poll = setInterval(function () {
    tries += 1;
    if (attach() || tries > 120) clearInterval(poll);
  }, 500);
  attach();
})();
